import { ReactNode, useCallback } from "react";
import { ITableRow } from "userful-chronos-app-common-js/dist/models/table/userfulTableInterface";
import TableRowFill from "../fill/TableRowFill";
import "./TableRow.scss";

type TableRowColumn = {
    id: string;
    component: ReactNode;
    width: number;
};

interface IProps {
    row: ITableRow;
    columns: TableRowColumn[];
    isOdd: boolean;
    rowIndex: number;
    onRowDoubleClick?: (row: ITableRow, rowIndex: number) => void;
    rowId?: string;
}

export default function TableRow({ row, rowIndex, onRowDoubleClick, rowId: rowIdProp, ...props }: IProps) {
    const resolveRowId = (rowData: ITableRow, fallback?: number) => {
        const rawId = (rowData as any)?.id ?? (rowData as any)?.rowId ?? fallback;
        if (typeof rawId === "object" && rawId !== null && "value" in rawId) {
            return String((rawId as any).value ?? (typeof fallback !== "undefined" ? fallback : ""));
        }
        if (typeof rawId === "string" || typeof rawId === "number") {
            return String(rawId);
        }
        return typeof fallback !== "undefined" ? String(fallback) : "";
    };

    const rowId = rowIdProp ?? resolveRowId(row, rowIndex);
    const isVisible = (row as any)?.visible !== false && (row as any)?.hidden !== true;

    const handleDoubleClick = useCallback(() => {
        if (!onRowDoubleClick) {
            return;
        }

        if ((row as any)?.isDroppable !== true) {
            return;
        }

        onRowDoubleClick(row, rowIndex);
    }, [onRowDoubleClick, row, rowIndex]);

    if (!rowId || !isVisible) {
        return null;
    }

    const renderRow = () => (
        <div
            className={`userful-table-row ${props.isOdd ? "userful-table-row-odd" : "userful-table-row-even"}`}
            onDoubleClick={handleDoubleClick}
        >
            {props.columns.map((cell) => (
                <div
                    key={cell.id}
                    id={cell.id}
                    className="userful-table-row-cell"
                    style={{ width: cell.width, minWidth: cell.width }}
                >
                    {cell.component}
                </div>
            ))}
            <TableRowFill />
        </div>
    );

    return renderRow();
}
